import React from 'react';
import styled, { css } from 'styled-components';
import { Palette } from '../utils/palette';
import { variant } from './variant';
import { Fonts } from '../utils';

export function Badge({ children, ...props }) {
  return <StyledBadge {...props}>{children}</StyledBadge>;
}

export const StyledBadge = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  border-radius: 20px;

  padding: 0px 12px;

  text-align: center;
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  ${variant(
  {
    default: css`
        background-color: ${Palette.HAZY_BLUE};
        color: ${Palette.WHITE};
      `,
    complete: css`
        background-color: rgba(0, 150, 136, 0.2);
        color: ${Palette.STAR_GREEN};
      `,
    archived: css`
        background-color: rgba(138, 70, 224, 0.2);
        color: ${Palette.PURPLE};
      `,
    reserved: css`
        background-color: ${Palette.BORDER_OUTLINE};
        color: ${Palette.DARK_ASH};
      `,
    inProgress: css`
        background-color: rgba(227, 132, 60, 0.2);
        color: ${Palette.RUSTY_ORANGE};
      `,
    open: css`
        background-color: rgba(70, 151, 224, 0.2);
        color: ${Palette.OCEANIC};
      `,
    danger: css`
        background-color: rgba(234, 68, 68, 0.2);
        color: ${Palette.ERROR};
      `,
    pending: css`
        background-color: rgba(227, 132, 60, 0.2);
        color: ${Palette.RUSTY_ORANGE};
      `,
    selected: css`
        background-color: ${Palette.SOLITUDE};
        color: ${Palette.HAZY_BLUE};
        border: 1px solid ${Palette.SOLITUDE};
      `,
    unselected: css`
        background-color: ${Palette.WHITE};
        color: ${Palette.HAZY_BLUE};
        border: 1px solid ${Palette.SOLITUDE};
      `,
    occupied: css`
        border: 1px solid ${Palette.CYAN_500};
        background-color: ${Palette.CYAN_100};
        color: ${Palette.CYAN_500};
      `,
    vacant: css`
        border: 1px solid ${Palette.YELLOW_700};
        background-color: ${Palette.YELLOW_100};
        color: ${Palette.YELLOW_700};
      `,
    outlineBlue: css`
        border: 1px solid ${Palette.CYAN_500};
      `,
    outlineOrange: css`
        border: 1px solid ${Palette.YELLOW_700};
      `,
    active: css`
        background-color: ${Palette.ACTIVE_GREEN_BACKGROUND};
        border: 1px solid ${Palette.ACTIVE_GREEN};
        color:  ${Palette.ACTIVE_GREEN};
      `,
    global: css`
        border: 1px solid ${Palette.VIOLET_500};
        background-color: ${Palette.VIOLET_100};
        color: ${Palette.VIOLET_500};
      `
  },
  'variant'
)}

  ${({ cssOverride }) => cssOverride};
`;
